import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['iframe']

  connect() {
    window.addEventListener('message', this.handleReceiveMessage);
  }

  handleReceiveMessage = (event) => {
    const { eventName, payload } = event?.data || {};
  
    if (eventName === 'pn-resize' && payload?.height) {
      const height = parseInt(payload.height) || 0;
  
      this.iframeTargets.forEach((iframe) => {
        if (iframe.contentWindow === event.source) {
          iframe.style.height = `${height + 15}px`;
        }
      });
    }
  };

  disconnect() {
    window.removeEventListener('message', this.handleReceiveMessage);
  }
}
